export default {"src":"/_next/static/media/home2.3bf568c3.svg","height":17,"width":20};